import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
var _colors_purple700_match, _colors_purple800_match;
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { isNumber } from 'lodash-es';
import { makeStyles, Slider } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
const STEP = 0.1;
const START_VALUE = 7.8;
const END_VALUE = 92.2;
const START_COLOR = (_colors_purple700_match = colors.purple700.match(/\w{2}/g)) === null || _colors_purple700_match === void 0 ? void 0 : _colors_purple700_match.map((hex)=>Number.parseInt(hex, 16));
const END_COLOR = (_colors_purple800_match = colors.purple800.match(/\w{2}/g)) === null || _colors_purple800_match === void 0 ? void 0 : _colors_purple800_match.map((hex)=>Number.parseInt(hex, 16));
const LINEAR_SCALE = END_COLOR && (START_COLOR === null || START_COLOR === void 0 ? void 0 : START_COLOR.map((_, i)=>(percent)=>percent * (END_COLOR[i] - START_COLOR[i]) + START_COLOR[i]));
function getValueAndPercent(rawValue) {
    const value = rawValue <= START_VALUE ? START_VALUE : rawValue >= END_VALUE ? END_VALUE : rawValue;
    return [
        value,
        (value - START_VALUE) / (END_VALUE - START_VALUE)
    ];
}
const getThumbStyle = (disabled)=>({
        height: 46,
        width: 46,
        marginTop: 4,
        marginLeft: -23,
        backgroundColor: disabled ? colors.dark120 : colors.dark50,
        '&, &:focus, &:hover': {
            boxShadow: "0px 1px 1px ".concat(colors.purple900)
        }
    });
const useStyles = makeStyles({
    root: {
        height: 54,
        color: 'currentColor'
    },
    thumb: _object_spread_props(_object_spread({}, getThumbStyle(false)), {
        '&.Mui-disabled': getThumbStyle(true)
    }),
    rail: {
        background: (param)=>{
            let { disabled } = param;
            return disabled ? "linear-gradient(90deg, ".concat(colors.dark700, " 0%, #B7B3C5 99.83%, #8873D4 100%)") : "linear-gradient(90deg, ".concat(colors.purple800, " 0%, currentColor 100%)");
        },
        height: 54,
        borderRadius: 90,
        opacity: 1
    }
});
export function SignSlider(param) {
    let { onSign, onChange, disabled } = param;
    const styles = useStyles({
        disabled
    });
    const [value, setValue] = useState(START_VALUE);
    const [percent, setPercent] = useState(0);
    const currentColor = useMemo(()=>'#' + (LINEAR_SCALE === null || LINEAR_SCALE === void 0 ? void 0 : LINEAR_SCALE.map((fn)=>Math.floor(fn(percent)).toString(16)).join('')), [
        percent
    ]);
    return /*#__PURE__*/ _jsx("div", {
        style: {
            color: currentColor
        },
        children: /*#__PURE__*/ _jsx(Slider, {
            disabled: disabled,
            value: value,
            classes: styles,
            valueLabelDisplay: "off",
            track: false,
            step: STEP,
            onChange: (_, rawValue)=>{
                if (isNumber(rawValue)) {
                    const [value, percent] = getValueAndPercent(rawValue);
                    setValue(value);
                    setPercent(percent);
                    onChange(percent);
                }
            },
            onChangeCommitted: (_, rawValue)=>{
                if (isNumber(rawValue)) {
                    const [, percent] = getValueAndPercent(rawValue);
                    if (percent >= 1) {
                        onSign();
                    }
                }
            }
        })
    });
}
